export default __webpack_public_path__ + "static/img_we_1-1025b9ef601cf1328060512310d9e6b7.png";